import React, { useEffect, useRef, useState } from "react";
import MobileHeader from "../../../layout/DriverLayout/Header";
import useVirtualViewport from "../../../../hooks/useVirtualViewport";
import { Box, Typography } from "@mui/material";
import CustomBadge from "../../../components/CustomBadge";
import StepsItems from "./StepItems";
import CustomInput from "../../../components/CustomInput";
import CustomInputLabel from "../../../components/CustomInputLabel";
import CustomAutoComple from "../../../components/CustomAutoComplete";
import CustomButton from "../../../components/CustomButton";
import ArrowLeftCircle from "../../../../media/images/icons/arrow-left-circle";
import { useAppSelector } from "../../../../hooks/useRedux";
import BottomTabbar from "../../../layout/DriverLayout/BottomTabbar";
import ArmadaInfo from "./Steps/ArmadaInfo";
import UploadDocuments from "./Steps/UploadDocuments";
import ResidenceInfo from "./Steps/ResidenceInfo";
import BankAccountInfo from "./Steps/BankAccountInfo";

export default function CompleteInfo() {
  const divRef = useRef<HTMLDivElement>(null);

  const { isOpenKeyboard } = useAppSelector((state) => state.setting);

  const [stepIndex, setStepIndex] = useState(1);

  const viewport = useVirtualViewport();
  const [hasScroll, setHasScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (divRef.current && divRef.current.scrollTop > 5) {
        // Do something when scrolled more than 20 pixels
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    if (divRef.current) {
      divRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      // Cleanup: remove the event listener when the component unmounts
      if (divRef.current) {
        divRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  function getForm(index: number) {
    switch (index) {
      case 1:
        return <ArmadaInfo />;

      case 2:
        return <UploadDocuments />;

      case 3:
        return <ResidenceInfo />;
      case 4:
        return <BankAccountInfo />;

      default:
        break;
    }
  }

  return (
    <>
      <MobileHeader
        title={
          <Typography
            sx={{
              fontWeight: 600,
              color: "secondary.main",
              fontSize: 16,
            }}
          >
            تکمیل اطلاعات حساب
          </Typography>
        }
        hasScroll={hasScroll}
      />
      <Box
        ref={divRef}
        sx={{
          flex: "1",
          overflowY: "auto",
          paddingX: "16px",
        }}
      >
        <StepsItems
          getStep={(step) => setStepIndex(step)}
          activeIndex={stepIndex}
        />

        {getForm(stepIndex)}
      </Box>

      {!isOpenKeyboard && <BottomTabbar />}
    </>
  );
}
